import { createRoot } from 'react-dom/client';
import { PanelToggleButton } from '@/components/PanelToggleButton';

/**
 * @param {HTMLButtonElement} button
 */
function replacePanelToggle(button) {
  const bodyId = button.getAttribute('aria-controls');
  if (!bodyId) return;

  const mount = document.createElement('span');
  mount.style.display = 'contents';
  button.replaceWith(mount);

  createRoot(mount).render(
    <PanelToggleButton
      id={button.id}
      className={button.className}
      bodyId={bodyId}
      initialExpanded={button.getAttribute('aria-expanded') === 'true'}
    />
  );
}

export function mountPanelToggles() {
  document.querySelectorAll('.settings-toggle').forEach((button) => {
    if (button instanceof HTMLButtonElement) {
      replacePanelToggle(button);
    }
  });
}
